import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Formulaire } from "../core/model/formulaire";
import { FormulaireService } from "../core/service/formulaire.service";
import { EditFormulaireComponent } from "./edit-formulaire/edit-formulaire.component";
import { AddFormulaireComponent } from "./add-formulaire/add-formulaire.component";

@Component({
  selector: "app-formulaire",
  templateUrl: "./formulaire.component.html",
  styleUrls: ["./formulaire.component.scss"],
})
export class FormulaireComponent implements OnInit {
  formulaires: Formulaire[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _formulaireService: FormulaireService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getFormulaires();
  }

  getFormulaires() {
    this._formulaireService.getAllFormulaires().subscribe(
      (data) => {
        this.formulaires = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  edit(formulaireId): void {
    const modalRef = this.modalService.open(EditFormulaireComponent, {
      centered: true,
    });
    modalRef.componentInstance.formulaireId = formulaireId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getFormulaires();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddFormulaireComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close
        this.getFormulaires();
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
